import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import FontAwesome5Icons from "react-native-vector-icons/FontAwesome5";

export const availableIcons: {
    [key: string]: {
        component?: any; // Make this match MaterialIcons and what not, sometimes TS sucks
        name: string;
    };
} = {
    store: {
        name: "store",
    },
    label: {
        name: "tags",
        component: FontAwesome5Icons,
    },
    help: {
        name: "life-ring",
        component: FontAwesome5Icons,
    },
    cart: {
        name: "shopping-basket",
        component: FontAwesome5Icons,
    },
    closedCircle: {
        name: "times-circle",
        component: FontAwesome5Icons,
    },
    closedReceipts: {
        name: "library-add-check",
    },
    copy: {
        name: "copy",
        component: FontAwesome5Icons,
    },
    delete: {
        name: "trash-alt",
        component: FontAwesome5Icons,
    },
    unknown: {
        name: "exclamation-circle",
        component: FontAwesome5Icons,
    },
    error: {
        name: "exclamation-circle",
        component: FontAwesome5Icons,
    },
    payment: {
        name: "piggy-bank",
        component: FontAwesome5Icons,
    },
    save: {
        name: "save",
    },
    department: {
        name: "building",
        component: FontAwesome5Icons,
    },
    close: {
        name: "close",
    },
    menu: {
        name: "menu",
        // component: MaterialIcons,
    },
    park: {
        name: "pause",
        component: FontAwesome5Icons,
    },
    parkCircle: {
        name: "pause-circle",
        component: FontAwesome5Icons,
    },
    cash: {
        name: "cash",
        component: MaterialCommunityIcons,
    },
    card: {
        name: "credit-card",
    },
    user: {
        name: "user-tie",
        component: FontAwesome5Icons,
    },
    return: {
        name: "undo",
        component: FontAwesome5Icons,
    },
    running: {
        name: "run-fast",
        component: MaterialCommunityIcons,
    },
    dashboard: {
        name: "tachometer-alt",
        component: FontAwesome5Icons,
    },
    settings: {
        name: "settings",
    },
    dropdown: {
        name: "arrow-drop-down",
    },
    dropup: {
        name: "arrow-drop-up",
    },
    default: {
        // used for menu items without icons
        name: "chevron-right",
    },
    basket: {
        name: "shopping-basket",
        component: FontAwesome5Icons,
    },
    cashRegister: {
        name: "cash-register",
        component: FontAwesome5Icons,
    },
    tags: {
        name: "id-card",
        component: FontAwesome5Icons,
    },
    offline: {
        name: "cloud-off",
        // component: MaterialIcons,
    },
    drawer: {
        name: "external-link-alt",
        component: FontAwesome5Icons,
    },
    "chevron-left": {
        name: "chevron-left",
        component: FontAwesome5Icons,
    },
    "chevron-right": {
        name: "chevron-right",
        component: FontAwesome5Icons,
    },
    "arrow-down": {
        name: "arrow-down",
        component: FontAwesome5Icons,
    },
    "arrow-up": {
        name: "arrow-up",
        component: FontAwesome5Icons,
    },
    "arrow-right": {
        name: "arrow-right",
        component: FontAwesome5Icons,
    },
    "arrow-left": {
        name: "arrow-left",
        component: FontAwesome5Icons,
    },
    "angle-down": {
        name: "angle-down",
        component: FontAwesome5Icons,
    },
    "angle-up": {
        name: "angle-up",
        component: FontAwesome5Icons,
    },
    "angle-left": {
        name: "angle-left",
        component: FontAwesome5Icons,
    },
    "angle-right": {
        name: "angle-right",
        component: FontAwesome5Icons,
    },
    edit: {
        name: "edit",
        component: FontAwesome5Icons,
    },
    "closed-receipts": {
        name: "times-circle",
        component: FontAwesome5Icons,
    },
    coins: {
        name: "coins",
        component: FontAwesome5Icons,
    },
    merchant: {
        name: "store-alt",
        component: FontAwesome5Icons,
    },
    order: {
        name: "file",
        component: FontAwesome5Icons,
    },
    shift: {
        name: "calendar-check",
        component: FontAwesome5Icons,
    },
    list: {
        name: "list-alt",
        component: FontAwesome5Icons,
    },
    signIn: {
        name: "sign-in-alt",
        component: FontAwesome5Icons,
    },
    signOut: {
        name: "sign-out-alt",
        component: FontAwesome5Icons,
    },

    warning: {
        name: "exclamation-triangle",
        component: FontAwesome5Icons,
    },

    info: {
        name: "info-circle",
        component: FontAwesome5Icons,
    },
    success: {
        name: "check-circle",
        // component: MaterialIcons,
    },
    check: {
        name: "check",
        // component: MaterialIcons,
    },
    subArrowRight: {
        name: "subdirectory-arrow-right",
        component: MaterialCommunityIcons,
    },
    grip: {
        name: "grip-vertical",
        component: FontAwesome5Icons,
    },
    times: {
        name: "times",
        component: FontAwesome5Icons,
    },
    plus: {
        name: "plus",
        component: FontAwesome5Icons,
    },
    "plus-circle": {
        name: "plus-circle",
        component: FontAwesome5Icons,
    },
    percentage: {
        name: "percentage",
        component: FontAwesome5Icons,
    },
    discount: {
        name: "percent",
        component: FontAwesome5Icons,
    },
    "return-item": {
        name: "undo",
        component: FontAwesome5Icons,
    },
    table: {
        name: "table",
        component: FontAwesome5Icons,
    },
    "times-circle": {
        name: "times-circle",
        component: FontAwesome5Icons,
    },
    backspace: {
        name: "backspace",
        component: FontAwesome5Icons,
    },
    "arrows-alt-v": {
        name: "arrows-alt-v",
        component: FontAwesome5Icons,
    },
    camera: {
        name: "camera",
        component: FontAwesome5Icons,
    },

    globe: {
        name: "globe",
        component: FontAwesome5Icons,
    },
    "money-check-alt": {
        name: "money-check-alt",
        component: FontAwesome5Icons,
    },
    sort: {
        name: "sort",
        component: FontAwesome5Icons,
    },
    "file-invoice-dollar": {
        name: "file-invoice-dollar",
        component: FontAwesome5Icons,
    },
    admin: {
        name: "user-secret",
        component: FontAwesome5Icons,
    },
    reseller: {
        name: "user-tie",
        component: FontAwesome5Icons,
    },
    "send-to": {
        name: "share-square",
        component: FontAwesome5Icons,
    },
    sync: {
        name: "sync",
        component: FontAwesome5Icons,
    },
    network: {
        name: "wifi",
        component: FontAwesome5Icons,
    },
    nfc: {
        name: "nfc",
        component: MaterialCommunityIcons,
    },
    barcode: {
        name: "barcode",
        component: MaterialCommunityIcons,
    },
    customers: {
        name: "suitcase",
        component: FontAwesome5Icons,
    },
    "id-card": {
        name: "id-card",
        component: FontAwesome5Icons,
    },
    receipt: {
        name: "receipt",
        component: FontAwesome5Icons,
    },
    split: {
        name: "call-split",
    },
    printer: {
        name: "printer",
        component: MaterialCommunityIcons,
    },
    catalog: {
        name: "table",
        component: FontAwesome5Icons,
    },
    calendar: {
        name: "calendar-alt",
        component: FontAwesome5Icons,
    },
    "calendar-clock": {
        name: "calendar-clock",
        component: MaterialCommunityIcons,
    },
    "point-of-sale": {
        name: "point-of-sale",
    },
    "customer-search": {
        name: "account-search",
        component: MaterialCommunityIcons,
    },
    asterisk: {
        name: "asterisk",
        component: FontAwesome5Icons,
    },
    "desktop-classic": {
        name: "desktop-classic",
        component: MaterialCommunityIcons,
    },

    undo: {
        name: "undo-alt",
        component: FontAwesome5Icons,
    },

    counter: {
        name: "counter",
        component: MaterialCommunityIcons,
    },
};
